module.exports = __webpack_public_path__ + "static/media/logo.183faa8a.png";